export default function registerDrawingPlugin(ckeditor) {
    if (ckeditor.plugins.get('ia-drawing-tool')) {
        return;
    }

    ckeditor.plugins.add('ia-drawing-tool', {
        icons: '',
        init: (editor) => {
            editor.addCommand('insertDrawing', {
                exec(editorToInsertIn) {
                    editorToInsertIn.drawingTriggerFunction();
                },
            });
            editor.ui.addButton('IA Drawing', {
                label: 'Insert Drawing',
                command: 'insertDrawing',
                toolbar: 'insert',
            });
        },
    });
}
